import type { ReactNode, TextareaHTMLAttributes } from 'react';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import TextArea from 'components/TextArea/TextArea';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

type FormInputPropsT<FormValuesT> = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  name: Path<FormValuesT> | string;
  label?: string | ReactNode;
  isRequired?: boolean;
  resizable?: boolean;
  rows: number;
};

const FormTextArea = <FormValuesT,>({
  name,
  resizable,
  rows,
  ...restProps
}: FormInputPropsT<FormValuesT>): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <TextArea resizable={resizable} rows={rows} {...register(name)} {...restProps} />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormTextArea;
